import { format } from "date-fns";
import { Calendar as CalendarIcon } from "lucide-react";

import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";
import { Calendar } from "@/components/ui/calendar";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { ComponentProps, useRef } from "react";
import { DayPicker } from "react-day-picker";

interface DatePickerProps {
  date?: Date;
  onDateChange?: (date: Date | undefined) => void;
  placeholder?: string;
  className?: string;
  disabled?: boolean;

  slotProps?: {
    calendar?: Omit<ComponentProps<typeof DayPicker>, "selected" | "onSelect">;
  };
}

export function DatePicker({
  date,
  onDateChange,
  placeholder = "Pick a date",
  className,
  disabled = false,
  slotProps = {
    calendar: {},
  },
}: DatePickerProps) {
  const popoverRef = useRef<HTMLButtonElement>(null);

  return (
    <Popover>
      <PopoverTrigger asChild ref={popoverRef}>
        <Button
          variant={"outline"}
          className={cn(
            "w-full justify-start text-left font-normal",
            !date && "text-muted-foreground",
            className
          )}
          disabled={disabled}
        >
          <CalendarIcon className="mr-2 h-4 w-4" />
          {date ? format(date, "PPP") : <span>{placeholder}</span>}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <Calendar
          {...(slotProps.calendar || {})}
          mode="single"
          selected={date}
          onSelect={(selected) => {
            onDateChange?.(selected);
            popoverRef.current?.click();
          }}
          initialFocus
        />
      </PopoverContent>
    </Popover>
  );
}
